import React from 'react';
import SideBar from '../../components/modules/left_sidebar';
import NavBar from '../../components/common/navbar';
import ScheduleFilterComponent from '../../components/Schedule/schedule_filter_component';
import DashboardSchedule from '../../components/Schedule/dashboard_schedule_list';
import { Calendar } from 'antd';
import services from '../../services';
import TkCalender from '../../components/tlelrik/TkCalender';
import Main from '../Demo/main';
import { withRouter } from 'react-router-dom';
import Lang from '../../lang'
var moment = require('moment')

const dateFormat = 'YYYY-MM-DD';

const ScheduleCalenderdata = [{
    id: 0,
    title: "Holiday",
    start: new Date("2019-08-14T11:00:00Z"),
    end: new Date("2019-08-16T11:01:00Z"),
    isAllDay: false
}]

const columnkeyMap = {
    title: Lang.langCheck.langRequest("Title"),
    entity: Lang.langCheck.langRequest("Entity"),
    status: Lang.langCheck.langRequest("Status"),
    observation: Lang.langCheck.langRequest("Observation"),
    attendance: Lang.langCheck.langRequest("Attendance")
}

class Schedule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            data: [],
            totalcount: '0',
            telkikTable: '',
            SortBy: 'ID',
            SortType: false,
            Paginate: false,
            Page: 1,
            PageSize: 10,
            show: false,
            calData: {}
        }
    }
    /* 
    Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.createpayload();
    }


    /* Para tornar a classificação de tabelas dinâmica com api */

    updatelistsort = (sort, key) => {
        this.setState({
            SortBy: key,
            SortType: sort
        }, () => this.createpayload())
    }

    /* Para tornar os dados da tabela dinâmicos com alterações de API */

    updatelistpagenumsize(PageSize, page_num) {
        this.setState({
            Page: page_num,
            PageSize: PageSize
        }, () => this.createpayload());
    }


    /* Faça uma solicitação de filtro de API */

    createpayload() {
        let data = {
            Filters: this.getFilters(),
            SortBy: this.state.SortBy,
            IsSortTypeDESC: this.state.SortType,
            IsPagination: this.state.Paginate,
            Page: this.state.Page,
            PageSize: this.state.PageSize
        };
        this.getList(data);
    }

    columnlist = Object.keys(columnkeyMap).map(function (key) {
        return { field: columnkeyMap[key], columnMenuType: 'checkbox' }
    });

    /* Para carregar o componente da tabela e definir todas as colunas  */
    createTabel = () => {
        let actionbuttons = { Edit: true, Redirect: true, Delete: true }
        //console.log("DATA",this.state.data);
        let telkikTable = <Main date={new Date()} deleteFunc={(id) => this.handleDelete(id)} list={this.state.data} actionbuttons={actionbuttons} columnlist={this.columnlist} ActionPerform={(action, id) => this.ActionPerform(action, id)} />
        this.setState({
            telkikTable: telkikTable
        })
    }

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        if (action == 'Edit') {
            // this.props.history.push({
            //     pathname:`/create_schedule?id=${row.id}`
            // })
            window.location = `/create_schedule?id=${row.id}`
        }
        if (action === 'Redirect') {
            // this.props.history.push({
            //     pathname:`/schedule_detail?id=${row.id}`
            // })
            window.location = `/schedule_detail?id=${row.id}`
        }
        if (action === 'Delete') {

        }
        if (action == 'GotoSchedule') {
            let params = new URLSearchParams(row.dataItem).toString();
            window.location = `/create_schedule?` + params
        }
    }

    /* Obter a chave do filtro do filtro personalizado */

    getFilters() {
        return null;
    }

    handleFilter = (data) => {
        let actionbuttons = { Edit: true, Redirect: false, Delete: true }
        let telkikTable = <Main date={new Date()} deleteFunc={(id) => this.handleDelete(id)} list={data} actionbuttons={actionbuttons} columnlist={this.columnlist} ActionPerform={(action, id) => this.ActionPerform(action, id)} />
        this.setState({
            telkikTable
        })
    }

    /* Deletar linha da tabela de dados */

    handleDelete = (id) => {

    }

    /* Api chamando dados da tabela */

    getList = async (data) => {
        let _data = await services.apiCall.requestApi("schedule/GetAll", data, 'post')
        if (_data) {
            let monthData = _data;
            // _data.map((_r,i)=>{
            //     if(_r.date){
            //         monthData.push(_r)
            //     }
            // })

            // _data.map((_row,index)=>(
            //     Object.keys(columnkeyMap).map(function(key) {
            //       _row[columnkeyMap[key]] = _row[key]
            //     })
            //   ));

            this.setState({
                data: _data,
                calData: monthData,
                totalcount: window.localStorage.getItem('table_total')
            }, () => this.createTabel())
        }
    }

    /* Para mudança de status da página */

    handleShow = (status) => {
        this.setState({
            show: status
        })
    }

    /*  Para renderizar o conteúdo html da página   */
    render() {
        //console.log("fdf",this.state)
        return (
            <div className="dashboard">
                <NavBar />
                <SideBar />
                <ScheduleFilterComponent data={this.state.data} handleFilter={(data) => this.handleFilter(data)} func={(status) => this.handleShow(status)} status={this.state.show} />
                <div className="row">
                    <div className="col-md-1">
                    </div>
                    <div className="col-md-11">
                        {
                            // !this.state.show ?
                            // <DashboardSchedule data={this.state} telkikTable={this.state.telkikTable} updatelistsort={(sort,columnkey)=>this.updatelistsort(sort,columnkey)} updatelistpagenumsize={(PageSize, page_num)=>this.updatelistpagenumsize(PageSize, page_num)} />
                            // :
                            this.state.calData.length > 0 &&
                            <TkCalender data={this.state.calData} ActionPerform={(action, row) => this.ActionPerform(action, row)} />
                        }

                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(Schedule);